var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.375L10.3837 14.2588L12 12.6425L12 17.75L13.25 17.75L13.25 12.6425L14.8662 14.2587L15.75 13.375L12.625 10.25L9.5 13.375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.5H2V1.5H7V5.25C7.00096 5.58123 7.13296 5.89861 7.36717 6.13283C7.60139 6.36704 7.91877 6.49904 8.25 6.5H12V8.375H13.25V5.25C13.2522 5.16786 13.2366 5.0862 13.2043 5.01067C13.1719 4.93514 13.1235 4.86753 13.0625 4.8125L8.6875 0.437501C8.63248 0.376457 8.56487 0.328079 8.48934 0.295707C8.41381 0.263335 8.33215 0.247741 8.25 0.250001H2C1.66877 0.250958 1.35139 0.382961 1.11717 0.617174C0.882959 0.851388 0.750956 1.16877 0.75 1.5V16.5C0.750956 16.8312 0.882959 17.1486 1.11717 17.3828C1.35139 17.617 1.66877 17.749 2 17.75H8.25V16.5ZM8.25 1.75L11.75 5.25H8.25V1.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocUpload);
export default __webpack_public_path__ + "static/media/doc_upload.8f01a97f19ff9a4504abed7d730c477f.svg";
export { ForwardRef as ReactComponent };